export default __webpack_public_path__ + "static/media/barcelona-logo.3aa8ea8d.png";